// Mirrors chatSummaryBus.ts: usePatient's cache (usePatients.ts) and the
// Details tab's contact-edit form live in separate component trees, with no
// shared state between them. A saved contact edit changes the name/email the
// queue list header already has cached, so this is how the edit tells that
// cache "the row for this id is stale" instead of it staying wrong until the
// next full remount.
type Listener = (id: string) => void;
const listeners = new Set<Listener>();

export function notifyPatientStale(id: string): void {
  for (const listener of listeners) {
    listener(id);
  }
}

export function subscribePatientStale(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
